(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/cylinder-wrapper/assets/product-cylinder.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/cylinder-wrapper/assets/product-cylinder.js');
'use strict';

var _svs$core$config$data;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const breakPoints = ['--screen-xs', '--screen-sm', '--screen-am'];

const getCSSVariableFromClass = (className, variable) => {
  const element = document.querySelector(className);
  if (element) {
    var _getComputedStyle$get;
    return ((_getComputedStyle$get = getComputedStyle(element).getPropertyValue(variable)) === null || _getComputedStyle$get === void 0 ? void 0 : _getComputedStyle$get.replace('px', 'w')) || '1w';
  }
  return '1w';
};
const getBreakPoints = () => breakPoints.map(breakPoint => getCSSVariableFromClass('.cylinder', breakPoint));
const CDN = (_svs$core$config$data = svs.core.config.data.svsconfig.cdn) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : '';

const ProductCylinder = _ref => {
  let _ref$game = _ref.game,
    game = _ref$game === void 0 ? 'lotto' : _ref$game,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 0 : _ref$position,
    _ref$isProduct = _ref.isProduct,
    isProduct = _ref$isProduct === void 0 ? true : _ref$isProduct;
  const _React$useState = React.useState(getBreakPoints()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    breakPoints = _React$useState2[0],
    setBreakPoints = _React$useState2[1];
  React.useLayoutEffect(() => {
    setBreakPoints(getBreakPoints());
  }, []);
  const getImageSize = size => "".concat(CDN, "/images/tb-ui/product-cylinders/").concat(game, "@").concat(size, "x.png");
  return React.createElement("img", {
    alt: game,
    className: "cylinder cylinder-".concat(game, " cylinder-").concat(position).concat(isProduct ? ' cylinder-product' : '')
    ,
    src: getImageSize(6),
    srcSet: "".concat(getImageSize(6), " ").concat(breakPoints[0], ",\n         ").concat(getImageSize(6), " ").concat(breakPoints[1])
  });
};
svs.tb_ui_react.cylinder_wrapper.ProductCylinder = ProductCylinder;

 })(window);